import React, { useCallback, useEffect, useMemo, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { Link, useNavigate } from "react-router-dom";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { all_routes } from "../../../router/all_routes";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Chart } from "primereact/chart";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import { Store } from "../../../types/shop.types";
import { DepartmentDto } from "../../../types/department.types";
import { useEmployee } from "../../../hooks/useEmployee";
import { CompanyDailyLeaveUsersDto, CompanyDailyStatsDto, CompanyActiveBreakUsersDto, CompanyDailyLateUsersDto } from "../../../types/attendanceDto.types";
import dailyRecordService from "../../../services/dailyRecord/dailyRecord.service";
import userService from "../../../services/user/user.service";
import breakService from "../../../services/break/break.service";
import { BirthdayUserDto, UserBirthdaysResponseDto } from "../../../types/user.types";
import { User } from "../../../types/user.types";
import BreakStatus from "./components/breakStatus";
import ClockInOutStatus from "./components/clockInOutStatus";
import { Avatar, Modal, Select, Tag, TimePicker, Button, message } from 'antd';
import type { Dayjs } from 'dayjs';
import locale from 'antd/lib/date-picker/locale/tr_TR';
import { getFileUrl } from '../../../utils/file.utils';
import { UserOutlined } from '@ant-design/icons';
import LeaveStatus from "./components/leaveStatus";
import TicketStatus from "./components/ticketStatus";
import { Trans, useTranslation } from "react-i18next";
import dayjs from "dayjs";
import 'dayjs/locale/tr';
import { handleApiError } from "../../../utils/errorHandler";
import FooterSection from "../../shared/components/footerSection";
import { RolesEnum } from "../../../types/route.types";
import ExcuseStatus from "./components/excuseStatus";
import LoadingSpinner from "../../shared/uiInterface/base-ui/LoadingSpinner";
import { useTour } from "../../../hooks/useTour";
import { useSetupTodo } from "../../../hooks/useSetupTodo"; // Kurulum durumunu almak için

const AdminDashboard = () => {
  const navigate = useNavigate();
  const {t} = useTranslation();
  const { startAppTour, isOpen: isTourOpen } = useTour();
  const { isSetupComplete, loading: setupLoading } = useSetupTodo(); // Kurulum durumunu al

  useEffect(() => {
    // Kurulum durumu verisi yüklenene kadar bekle
    if (setupLoading) {
      return;
    }

    // Kural 1: Kurulum zaten tamamsa, turu ASLA otomatik başlatma.
    if (isSetupComplete) {
      return;
    }

    // Kural 2: Kurulum tamamlanmadıysa, tur daha önce görülmüş mü diye kontrol et.
    const hasSeenTour = localStorage.getItem('hasSeenAutoTour');
    if (!hasSeenTour && !isTourOpen) {
      startAppTour();
    }
  }, [isSetupComplete, setupLoading, isTourOpen, startAppTour]);

  const [empDepartment, setEmpDepartment] = useState<any>({
    chart: {
      height: 235,
      type: "bar",
      padding: {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
      },
      toolbar: {
        show: false,
      },
    },
    fill: {
      colors: ["#F26522"], // Fill color for the bars
      opacity: 1, // Adjust opacity (1 is fully opaque)
    },
    colors: ["#F26522"],
    grid: {
      borderColor: "#E5E7EB",
      strokeDashArray: 5,
      padding: {
        top: -20,
        left: 0,
        right: 0,
        bottom: 0,
      },
    },
    plotOptions: {
      bar: {
        borderRadius: 5,
        horizontal: true,
        barHeight: "35%",
        endingShape: "rounded",
      },
    },
    dataLabels: {
      enabled: false,
    },
    series: [
      {
        data: [
          
        ],
        name: t("dashboard.departments.employee"),
      },
    ],
    xaxis: {
      categories: [
        
      ],
      labels: {
        style: {
          colors: "#111827",
          fontSize: "13px",
        },
      },
    },
  });

  const [empBranch, setEmpBranch] = useState<any>({
    chart: {
      height: 235,
      type: "bar",
      padding: {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
      },
      toolbar: {
        show: false,
      },
    },
    fill: {
      colors: ["#4CAF50"],
      opacity: 1,
    },
    colors: ["#4CAF50"],
    grid: {
      borderColor: "#E5E7EB",
      strokeDashArray: 5,
      padding: {
        top: -20,
        left: 0,
        right: 0,
        bottom: 0,
      },
    },
    plotOptions: {
      bar: {
        borderRadius: 5,
        horizontal: true,
        barHeight: "35%",
        endingShape: "rounded",
      },
    },
    dataLabels: {
      enabled: false,
    },
    series: [
      {
        data: [
         
        ],
        name: t("dashboard.branches.employee"),
      },
    ],
    xaxis: {
      categories: [
        
      ],
      labels: {
        style: {
          colors: "#111827",
          fontSize: "13px",
        },
      },
    },
  });

  const routes = all_routes;
  const { user } = useSelector((state: RootState) => state.auth);
  const { departments, shops, fetchDepartmentsAndShops } = useEmployee();
  const { getUsersBirthdays, getUsers } = userService;
  const [chartData, setChartData] = useState({});
  const [loading, setLoading] = useState(false);
  const [chartOptions, setChartOptions] = useState({});
  const [companyDailyStats, setCompanyDailyStats] = useState<CompanyDailyStatsDto | null>(null);
  const { getCompanyDailyStats } = dailyRecordService;
  const [birthdayUsers, setBirthdayUsers] = useState<{
    today: BirthdayUserDto[];
    thisWeek: BirthdayUserDto[];
    thisMonth: BirthdayUserDto[];
  }>({ today: [], thisWeek: [], thisMonth: [] });
  const [companyDailyLeaveUsers, setCompanyDailyLeaveUsers] = useState<CompanyDailyLeaveUsersDto[]>([]);
  const [isLeaveUsersModalVisible, setIsLeaveUsersModalVisible] = useState(false);
  const [isBreakUsersModalVisible, setIsBreakUsersModalVisible] = useState(false);
  const [activeBreakUsers, setActiveBreakUsers] = useState<CompanyActiveBreakUsersDto[]>([]);
  const [isEndBreakModalVisible, setIsEndBreakModalVisible] = useState(false);
  const [selectedBreakUser, setSelectedBreakUser] = useState<CompanyActiveBreakUsersDto | null>(null);
  const [endTime, setEndTime] = useState<Dayjs | null>(null);
  const [updatingBreak, setUpdatingBreak] = useState(false);
  const [companyDailyLateUsers, setCompanyDailyLateUsers] = useState<CompanyDailyLateUsersDto[]>([]);
  const [isLateUsersModalVisible, setIsLateUsersModalVisible] = useState(false);
  const [companyUsers, setCompanyUsers] = useState<User[]>([]);
  const [checkedInEmployees, setCheckedInEmployees] = useState<any[]>([]);
  const [isCheckedInEmployeesModalVisible, setIsCheckedInEmployeesModalVisible] = useState(false);
  const [mainLoading, setMainLoading] = useState(true); // Ana yükleme durumu için yeni state
  const [selectedDepartments, setSelectedDepartments] = useState<number[]>([]);
  const [selectedBranches, setSelectedBranches] = useState<number[]>([]);
  const [usersBreakCount, setUsersBreakCount] = useState<number>(0);
  const [usersLeaveCount, setUsersLeaveCount] = useState<number>(0);
  const [usersLateCount, setUsersLateCount] = useState<number>(0);

  const [dataLoadingStates, setDataLoadingStates] = useState({
    users: false,
    birthdays: false,
    checkedInEmployees: false,
    activeBreakUsers: false,
    leaveUsers: false,
    lateUsers: false
  });

  const handleCompanyDailyLeaveUsers = () => {
    setIsLeaveUsersModalVisible(true);
    loadLeaveUsers();
  };

  const handleDepartmentFilter = (value: number[]) => {
    setSelectedDepartments(value);
  };

  const handleBranchFilter = (value: number[]) => {
    setSelectedBranches(value);
  };

  const clearFilters = () => {
    setSelectedDepartments([]);
    setSelectedBranches([]);
  };
  
  const handleBreakCountUpdate = (count: number) => {
    setUsersBreakCount(count);
  };
  
  const handleLeaveCountUpdate = (count: number) => {
    setUsersLeaveCount(count);
  };
  
  const handleLateCountUpdate = (count: number) => {
    setUsersLateCount(count);
  };
  const isUserMatchesFilter = (user: any, userDepartments?: any[], userBranches?: any[] , isAll?: boolean) => {
    // Farklı veri yapıları için uyumlu hale getir
    const departments = userDepartments || user?.department || user.departments || [];
    const branches = userBranches || user?.branch || user.branches || [];
    
    const userDepartmentIds = departments?.map((d: any) => d.id);
    const userBranchIds = branches?.map((b: any) => b.id);

    const departmentMatch = selectedDepartments?.length === 0 || 
      selectedDepartments?.some(id => userDepartmentIds.includes(id));
    
    
    const branchMatch = selectedBranches?.length === 0 ||   
      selectedBranches.some(id => userBranchIds.includes(id));
    // const userStatusMatch = user.status === 'active';
    return departmentMatch && branchMatch;
  };

  const filteredCompanyUsers = companyUsers
    ?.filter(user => isUserMatchesFilter(user, user.department, user.branch, true))
    ?.filter(user => user.status === 'active')
    ?.filter(user => user.role !== RolesEnum.ADMIN && user.role !== RolesEnum.SUPERADMIN);

  const filteredBirthdayUsers = {
    today: birthdayUsers?.today?.filter(user => 
      isUserMatchesFilter(user, user.department, user.branch)
    ),
    thisWeek: birthdayUsers?.thisWeek?.filter(user => 
      isUserMatchesFilter(user, user.department, user.branch)
    ),
    thisMonth: birthdayUsers?.thisMonth?.filter(user => 
      isUserMatchesFilter(user, user.department, user.branch)
    )
  };

  const filteredCheckedInEmployees = checkedInEmployees?.filter(employee => 
    isUserMatchesFilter(employee, employee.department, employee.branch)
  );

  const filteredActiveBreakUsers = activeBreakUsers?.filter(user => {
    // activeBreakUsers'ın veri yapısına göre ayarla
    const departments = Array.isArray(user.department) ? user.department : [];
    const branches = Array.isArray(user.branch) ? user.branch : [];
    return isUserMatchesFilter(user, departments, branches);
  });
  
  const filteredCompanyDailyLeaveUsers = companyDailyLeaveUsers?.filter(user => {
    // companyDailyLeaveUsers'ın veri yapısına göre ayarla
    const departments = Array.isArray(user.user?.department) ? user.user.department : [];
    const branches = Array.isArray(user.user?.branch) ? user.user.branch : [];
    return isUserMatchesFilter(user, departments, branches);
  });
  
  const filteredCompanyDailyLateUsers = companyDailyLateUsers?.filter(user => {
    // companyDailyLateUsers'ın veri yapısına göre ayarla
    const departments = Array.isArray(user.department) ? user.department : [];
    const branches = Array.isArray(user.branch) ? user.branch : [];
    return isUserMatchesFilter(user, departments, branches);
  });

  
  const handleActiveBreakUsers = () => {
    setIsBreakUsersModalVisible(true);
    loadActiveBreakUsers();
  };

  const handleCompanyDailyLateUsers = () => {
    setIsLateUsersModalVisible(true);
    loadLateUsers();
  };

  const handleCheckedInEmployees = () => {
    setIsCheckedInEmployeesModalVisible(true);
    loadCheckedInEmployees();
  };
  
  const computedStats = useMemo(() => {
    if (!companyDailyStats) return null;
    const noShiftToday = companyDailyStats.employeesWithNoShiftToday ?? 0;
    const rawDidNotCome = companyDailyStats.totalEmployees - companyDailyStats.checkedInEmployees;
    // Gelmedi = gelmesi gereken ama gelmeyen; bugün vardiyası olmayanları sayma
    const didNotCome = Math.max(0, rawDidNotCome - noShiftToday);
    return {
      totalEmployees: companyDailyStats.totalEmployees,
      checkedInEmployees: companyDailyStats.checkedInEmployees,
      lateEmployees: companyDailyStats.lateEmployees,
      onLeaveEmployees: companyDailyStats.onLeaveEmployees,
      activeBreaks: companyDailyStats.activeBreaks,
      didNotCome,
      noShiftToday
    };
  }, [companyDailyStats]);

  // console.log(filteredCheckedInEmployees);
  
  const widgetStats = useMemo(() => ({
    checkedIn: filteredCheckedInEmployees?.length,
    total: filteredCompanyUsers?.length,
    late: filteredCompanyDailyLateUsers?.length,
    onLeave: filteredCompanyDailyLeaveUsers?.length,
    onBreak: filteredActiveBreakUsers?.length
  }), [filteredCheckedInEmployees?.length, filteredCompanyUsers?.length, filteredCompanyDailyLateUsers?.length, filteredCompanyDailyLeaveUsers?.length, filteredActiveBreakUsers?.length]);

  
   const initialDataFetch = useCallback(async () => {
    setMainLoading(true);
    try {
      // 1. Öncelik: Temel istatistikler ve departman/şube verileri
      const [dailyStats] = await Promise.all([
        getCompanyDailyStats(),
        fetchDepartmentsAndShops() // Bu useEmployee hook'unda departments/shops state'ini günceller
      ]);

      setCompanyDailyStats(dailyStats);
      
    } catch (error: any) {
      handleApiError(error, t);
    } finally {
      setMainLoading(false);
    }
  }, [getCompanyDailyStats, fetchDepartmentsAndShops, t]);

  const loadUsersData = useCallback(async () => {
    if (companyUsers?.length > 0) return; // Zaten yüklenmişse tekrar yükleme
    
    setDataLoadingStates(prev => ({ ...prev, users: true }));
    try {
      const users = await getUsers();
      setCompanyUsers(users);
    } catch (error: any) {
      handleApiError(error, t);
    } finally {
      setDataLoadingStates(prev => ({ ...prev, users: false }));
    }
  }, [getUsers, t, companyUsers?.length]);

  const loadBirthdaysData = useCallback(async () => {
    if (!user?.companyId || birthdayUsers?.today?.length > 0) return;
    
    setDataLoadingStates(prev => ({ ...prev, birthdays: true }));
    try {
      const birthdays = await getUsersBirthdays(user.companyId);
      setBirthdayUsers(birthdays);
    } catch (error: any) {
      handleApiError(error, t);
    } finally {
      setDataLoadingStates(prev => ({ ...prev, birthdays: false }));
    }
  }, [user?.companyId, getUsersBirthdays, t, birthdayUsers?.today?.length]);

  const loadCheckedInEmployees = useCallback(async () => {
    if (checkedInEmployees?.length > 0) return;
    
    setDataLoadingStates(prev => ({ ...prev, checkedInEmployees: true }));
    try {
      const employees = await dailyRecordService.checkedInEmployeesToday();
      setCheckedInEmployees(employees);
    } catch (error: any) {
      handleApiError(error, t);
    } finally {
      setDataLoadingStates(prev => ({ ...prev, checkedInEmployees: false }));
    }
  }, [t, checkedInEmployees?.length]);

  const loadActiveBreakUsers = useCallback(async () => {
    if (activeBreakUsers?.length > 0) return;
    
    setDataLoadingStates(prev => ({ ...prev, activeBreakUsers: true }));
    try {
      const users = await dailyRecordService.getCompanyActiveBreakUsers();
      setActiveBreakUsers(users);
    } catch (error: any) {
      handleApiError(error, t);
    } finally {
      setDataLoadingStates(prev => ({ ...prev, activeBreakUsers: false }));
    }
  }, [t, activeBreakUsers?.length]);

  const loadLeaveUsers = useCallback(async () => {
    if (!user?.companyId || companyDailyLeaveUsers?.length > 0) return;
    
    setDataLoadingStates(prev => ({ ...prev, leaveUsers: true }));
    try {
      const users = await dailyRecordService.getCompanyDailyLeaveUsers(user.companyId);
      setCompanyDailyLeaveUsers(users);
    } catch (error: any) {
      handleApiError(error, t);
    } finally {
      setDataLoadingStates(prev => ({ ...prev, leaveUsers: false }));
    }
  }, [user?.companyId, t, companyDailyLeaveUsers?.length]);

  const loadLateUsers = useCallback(async () => {
    if (companyDailyLateUsers?.length > 0) return;
    
    setDataLoadingStates(prev => ({ ...prev, lateUsers: true }));
    try {
      const today = new Date().toISOString().split('T')[0];
      const users = await dailyRecordService.getCompanyDailyLateUsers(today);
      setCompanyDailyLateUsers(users);
    } catch (error: any) {
      handleApiError(error, t);
    } finally {
      setDataLoadingStates(prev => ({ ...prev, lateUsers: false }));
    }
  }, [t, companyDailyLateUsers?.length]);

  // İlk veri yüklemesi için useEffect
  useEffect(() => {
    initialDataFetch();
  }, [initialDataFetch]); // Sadece initialDataFetch değiştiğinde çalışır

  useEffect(() => {
    if (!mainLoading && companyDailyStats) {
      const timer = setTimeout(() => {
        // Staggered loading - veriler arasında kısa aralıklarla yükle
        loadUsersData();
        loadCheckedInEmployees();
        loadBirthdaysData();
        loadActiveBreakUsers();
        loadLeaveUsers();
        loadLateUsers();
      }, 100);

      return () => clearTimeout(timer);
    }
  }, [mainLoading, companyDailyStats, loadUsersData, loadCheckedInEmployees, loadBirthdaysData, loadActiveBreakUsers, loadLeaveUsers, loadLateUsers]);

  // Grafikler için veri işleme (departments, shops veya companyDailyStats değiştiğinde)
  useEffect(() => {
    // Departman ve şube grafikleri
    updateDepartmentAndShopCharts();
    updateAttendanceChart();

  }, [departments, shops, companyDailyStats,t]);

  // useEffect(() => {
  //     getUsers()
  //       .then(setCompanyUsers)
  //       .catch(err => handleApiError(err,t));
  // }, []);
  // Departman ve şube grafik verilerini güncelleme işlevi
  const updateDepartmentAndShopCharts = () => {
    if (departments?.length > 0) {
      const topDepartments = departments?.slice(0, 5);
      setEmpDepartment((prevState: any) => ({
        ...prevState,
        series: [{
          data: topDepartments?.map(dept => dept.employeeCount.toString()),
          name: t("dashboard.departments.employee"),
        }],
        xaxis: {
          ...prevState.xaxis,
          categories: topDepartments?.map(dept => dept.name),
        },
      }));
    }
    
    if (shops?.length > 0) {
      const topShops = shops?.slice(0, 5);
      setEmpBranch((prevState: any) => ({
        ...prevState,
        series: [{
          data: topShops?.map((shop: any) => shop.employeeCount.toString()),
          name: t("dashboard.branches.employee"),
        }],
        xaxis: {
          ...prevState.xaxis,
          categories: topShops?.map(shop => shop.name),
        },
      }));
    }
  };

  const formatTime = (dateString: string) => {
    if (!dateString) return '-';
    try {
      return dayjs(dateString).format('HH:mm');
    } catch (error) {
      // console.error('Tarih ayrıştırma hatası:', error);
      return '-';
    }
  };

  // Donut grafik verilerini güncelleme işlevi
  const updateAttendanceChart = () => {
    const noShiftToday = companyDailyStats?.employeesWithNoShiftToday ?? 0;
    const showNoShiftToday = noShiftToday > 0;
    const rawDidNotCome = companyDailyStats
      ? companyDailyStats.totalEmployees - companyDailyStats.checkedInEmployees
      : 0;
    const didNotCome = Math.max(0, rawDidNotCome - noShiftToday);
    const checkedIn = companyDailyStats?.checkedInEmployees ?? 0;
    const labels = [
      t("dashboard.attendanceStatus.checkedIn", "Giriş yapan"),
      t("dashboard.attendanceStatus.late", "Gecikmeli"),
      t("dashboard.attendanceStatus.onLeave", "İzinli"),
      t("dashboard.attendanceStatus.onBreak", "Molada"),
      t("dashboard.attendanceStatus.didNotCome", "Gelmedi"),
      ...(showNoShiftToday ? [t("dashboard.attendanceStatus.noShiftToday", "Bugün vardiyası yok")] : [])
    ];
    const chartValues = [
      checkedIn,
      companyDailyStats?.lateEmployees ?? 0,
      companyDailyStats?.onLeaveEmployees ?? 0,
      companyDailyStats?.activeBreaks ?? 0,
      didNotCome,
      ...(showNoShiftToday ? [noShiftToday] : [])
    ];
    const colors = ["#10b981", "#0C4B5E", "#007bff", "#FFC107", "#E70D0D", ...(showNoShiftToday ? ["#6c757d"] : [])];
    const data = {
      labels,
      datasets: [{
        label: t("dashboard.departments.employee"),
        data: chartValues,
        backgroundColor: colors,
        borderWidth: 5,
        borderRadius: 10,
        borderColor: "#fff",
        hoverBorderWidth: 0,
        cutout: "60%",
      }],
    };
    
    const options = {
      rotation: -100,
      circumference: 200,
      layout: {
        padding: {
          top: -20,
          bottom: -20,
        },
      },
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: false,
        },
      },
    };
    
    setChartData(data);
    setChartOptions(options);
  };

  // Doğum Günleri bölümü için JSX
  const renderBirthdaySection = () => (
    <div className="col-xxl-4 col-xl-6 d-flex">
      <div className="card flex-fill">
        <div className="card-header pb-2 d-flex align-items-center justify-content-start flex-wrap">
          <i className="ti ti-cake me-2"></i>
          <h5 className="mb-2">{t("dashboard.birthdays.title")}</h5>
        </div>
        <div className="card-body pb-1" style={{ maxHeight: '350px', overflowY: 'auto' }}>
          <h6 className="mb-2">{t("dashboard.birthdays.today")}</h6>
          {filteredBirthdayUsers?.today?.length > 0 ? (
            filteredBirthdayUsers?.today?.map((user) => (
              <div key={user.userId} className="bg-light p-2 border border-dashed rounded-top mb-3">
                <div className="d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center">
                    {user.profilePicture ? (
                      <Avatar src={getFileUrl(user.profilePicture)} size="large" />
                    ) : (
                      <Avatar src={user?.gender === 'male' ? '/assets/img/man.png' : '/assets/img/woman.png'} size="default" />
                    )}
                    <div className="ms-2 overflow-hidden">
                      <h6 className="fs-medium">{user.name}</h6>
                      <p className="fs-13">
                        {user.department?.map(d => d.name).join(', ')} - {user.branch?.map(b => b.name).join(', ')}
                      </p>
                    </div>
                  </div>
                  <div>
                    <span className="fs-10 fw-medium d-inline-flex align-items-center badge badge-info">
                      <i className="ti ti-cake me-1" />
                      {user?.birthDate}
                    </span>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="bg-light p-2 border border-dashed rounded-top mb-3">
              <p className="text-center mb-0">
                {selectedDepartments.length > 0 || selectedBranches.length > 0 
                  ? "Seçilen filtreye göre bugün doğum günü olan çalışan yok"
                  : t("dashboard.birthdays.noBirthdayToday")
                }
              </p>
            </div>
          )}

          <h6 className="mb-2">{t("dashboard.birthdays.thisWeek")}</h6>
          {filteredBirthdayUsers?.thisWeek?.length > 0 ? (
            filteredBirthdayUsers?.thisWeek?.map((user) => (
              <div key={user.userId} className="bg-light p-2 border border-dashed rounded-top mb-3">
                <div className="d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center">
                    {user.profilePicture ? (
                      <Link to={all_routes.employeedetails.replace(':id', user.userId.toString())} className="avatar">
                        <ImageWithBasePath
                          src={getFileUrl(user.profilePicture)}
                          className="rounded-circle"
                          alt="img"
                        />
                      </Link>
                    ) : (
                      <Link to={all_routes.employeedetails.replace(':id', user.userId.toString())} className="avatar">
                        <Avatar src={user?.gender === 'male' ? '/assets/img/man.png' : '/assets/img/woman.png'} size="large" />
                      </Link> 
                    )}
            
                    <div className="ms-2 overflow-hidden">
                      <h6 className="fs-medium">{user.name}</h6>
                      <p className="fs-13">
                        {user.department?.map(d => d.name).join(', ')} - {user.branch?.map(b => b.name).join(', ')}
                      </p>
                    </div>
                  </div>
                  <div>
                    <span className="fs-10 fw-medium d-inline-flex align-items-center badge badge-info">
                      <i className="ti ti-cake me-1" />
                      {user?.birthDate}
                    </span>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="bg-light p-2 border border-dashed rounded-top mb-3">
              <p className="text-center mb-0">
                {selectedDepartments.length > 0 || selectedBranches.length > 0 
                  ? "Seçilen filtreye göre bu hafta doğum günü olan çalışan yok"
                  : t("dashboard.birthdays.noBirthdayThisWeek")
                }
              </p>
            </div>
          )}

          <h6 className="mb-2">{t("dashboard.birthdays.thisMonth")}</h6>
          {filteredBirthdayUsers?.thisMonth?.length > 0 ? (
            filteredBirthdayUsers?.thisMonth?.map((user) => (
              <div key={user.userId} className="bg-light p-2 border border-dashed rounded-top mb-3">
                <div className="d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center">
                    <span className="avatar">
                      {user.profilePicture ? (
                        <Link to={all_routes.employeedetails.replace(':id', user.userId.toString())}>
                          <Avatar
                            src={getFileUrl(user.profilePicture)}
                            className="rounded-circle"
                            alt="img"
                          />
                        </Link>
                      ) : (
                        <Link to={all_routes.employeedetails.replace(':id', user.userId.toString())}>
                          <Avatar src={user?.gender === 'male' ? '/assets/img/man.png' : '/assets/img/woman.png'} size="large" />
                        </Link>
                      )}
                    </span>
                    <div className="ms-2 overflow-hidden">
                      <h6 className="fs-medium">{user.name}</h6>
                      <p className="fs-13">
                        {user.department?.map(d => d.name).join(', ')} - {user.branch?.map(b => b.name).join(', ')}
                      </p>
                    </div>
                  </div>
                  <div>
                    <span className="fs-10 fw-medium d-inline-flex align-items-center badge badge-info">
                      <i className="ti ti-cake me-1" />
                      {user?.birthDate}
                    </span>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="bg-light p-2 border border-dashed rounded-top mb-3">
              <p className="text-center mb-0">
                {selectedDepartments.length > 0 || selectedBranches.length > 0 
                  ? "Seçilen filtreye göre bu ay doğum günü olan çalışan yok"
                  : t("dashboard.birthdays.noBirthdayThisMonth")
                }
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );

  const renderLeaveUsersModal = () => (
    <Modal
      title={t("dashboard.leaveRequests.title")}
      open={isLeaveUsersModalVisible}
      onCancel={() => setIsLeaveUsersModalVisible(false)}
      footer={null}
      width={700}
    >
      <div className="table-responsive">
        <table className="table table-nowrap mb-0">
          <thead>
            <tr>
              <th>{t("dashboard.leaveRequests.employee")}</th>
              <th>{t("dashboard.leaveRequests.leaveType")}</th>
              <th>{t("dashboard.leaveRequests.startDate")}</th>
              <th>{t("dashboard.leaveRequests.endDate")}</th>
            </tr>
          </thead>
          <tbody>
            {filteredCompanyDailyLeaveUsers?.map((leaveUser) => (
              <tr key={leaveUser.id}>
                <td>
                  <div className="d-flex align-items-center">
                    <div className="avatar avatar-md me-2">
                      {leaveUser.user?.profilePicture ? (
                        <Avatar src={getFileUrl(leaveUser.user.profilePicture)} size="large" />
                      ) : (
                        <Avatar src={leaveUser.user?.gender === 'male' ? '/assets/img/man.png' : '/assets/img/woman.png'} size="large" />
                      )}
                    </div>
                    <div>
                      <Link to={all_routes.employeedetails.replace(':id', leaveUser.user?.id.toString() || '')}>
                        <h6 className="mb-0">{leaveUser.user?.name}</h6>
                        <small>
                          {Array.isArray(leaveUser.user?.department) 
                            ? leaveUser.user.department.map(d => d.name).join(', ') 
                            : '-'
                          } - {Array.isArray(leaveUser.user?.branch) 
                            ? leaveUser.user.branch.map(b => b.name).join(', ') 
                            : '-'
                          }
                        </small>
                      </Link>
                    </div>
                  </div>
                </td>
                <td>
                  <span className="text-capitalize">
                    {t(`leaveTypes.${leaveUser.type}`)}                  
                  </span>
                </td>
                <td>{dayjs(leaveUser.startDate, "DD.MM.YYYY").format("L")}</td>
                <td>{dayjs(leaveUser.endDate, "DD.MM.YYYY").format("L")}</td>
              </tr>
            ))}
            {companyDailyLeaveUsers?.length === 0 && (
              <tr>
                <td colSpan={5} className="text-center">
                  {t("dashboard.leaveRequests.noLeaveToday")}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </Modal>
  );

  const handleEndBreakClick = (breakUser: CompanyActiveBreakUsersDto) => {
    setSelectedBreakUser(breakUser);
    // Başlangıç saatinden sonraki bir saat varsayılan olarak seçiliyor
    const startTime = dayjs(breakUser.startTime);
    setEndTime(startTime.add(breakUser.minutesOnBreak, 'minute'));
    setIsEndBreakModalVisible(true);
  };

  const handleEndBreakConfirm = async () => {
    if (!selectedBreakUser || !endTime) {
      message.error('Lütfen bitiş saatini seçin');
      return;
    }

    const startTime = dayjs(selectedBreakUser.startTime);
    if (endTime.isBefore(startTime)) {
      message.error('Bitiş saati başlangıç saatinden önce olamaz');
      return;
    }

    setUpdatingBreak(true);
    try {
      const endTimeISO = endTime.toISOString();
      await breakService.updateEndTime(selectedBreakUser.breakId, endTimeISO);
      message.success('Mola başarıyla sonlandırıldı');
      setIsEndBreakModalVisible(false);
      setSelectedBreakUser(null);
      setEndTime(null);
      // Mola listesini yeniden yükle
      setActiveBreakUsers([]);
      loadActiveBreakUsers();
    } catch (error: any) {
      handleApiError(error, t);
    } finally {
      setUpdatingBreak(false);
    }
  };

  const renderBreakUsersModal = () => (
    <Modal
      title={t("modals.onBreakEmployees.title")}
      open={isBreakUsersModalVisible}
      onCancel={() => setIsBreakUsersModalVisible(false)}
      footer={null}
      width={800}
      bodyStyle={{ maxHeight: '60vh', overflow: 'auto' }}
    >
      <div className="table-responsive">
        <table className="table table-nowrap mb-0">
          <thead style={{ position: 'sticky', top: 0, backgroundColor: 'white', zIndex: 1 }}>
            <tr>
              <th>{t("modals.onBreakEmployees.employee")}</th>
              <th>{t("modals.onBreakEmployees.breakType")}</th>
              <th>{t("modals.onBreakEmployees.startTime")}</th>
              <th>{t("modals.onBreakEmployees.duration")}</th>
              <th>İşlemler</th>
            </tr>
          </thead>
          <tbody>
            {filteredActiveBreakUsers?.map((breakUser) => (
              <tr key={breakUser.breakId}>
                <td>
                  <div className="d-flex align-items-center">
                    <div className="avatar avatar-md me-2">
                      {breakUser.profilePicture ? (
                        <Avatar src={getFileUrl(breakUser.profilePicture)} size="large" />
                      ) : (
                        <Avatar src={breakUser.gender === 'male' ? '/assets/img/man.png' : '/assets/img/woman.png'} size="large" />
                      )}
                    </div>
                    <div>
                      <Link to={all_routes.employeedetails.replace(':id', breakUser.userId.toString() || '')}>
                        <h6 className="mb-0">{breakUser.userName}</h6>
                        <small>
                          {Array.isArray(breakUser.department) 
                            ? breakUser.department.map(d => d.name).join(', ') 
                            : '-'
                          } - {Array.isArray(breakUser.branch) 
                            ? breakUser.branch.map(b => b.name).join(', ') 
                            : '-'
                          }
                        </small>
                      </Link>
                    </div>
                  </div>
                </td>
                <td>
                  <span className="text-capitalize">
                    {t(`breakTypes.${breakUser.type}`)}
                  </span>
                </td>
                <td>{formatTime(breakUser.startTime)}</td>
                <td>{breakUser.minutesOnBreak}</td>
                <td>
                  <Button
                    type="primary"
                    size="small"
                    onClick={() => handleEndBreakClick(breakUser)}
                    style={{ backgroundColor: '#7338a1', borderColor: '#7338a1' }}
                  >
                    Molasını Bitir
                  </Button>
                </td>
              </tr>
            ))}
            {activeBreakUsers.length === 0 && (
              <tr>
                <td colSpan={5} className="text-center">
                  {t("modals.onBreakEmployees.noBreakToday")}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      
      {/* Bitiş Saati Seçim Modalı */}
      <Modal
        title="Mola Bitiş Saati Seç"
        open={isEndBreakModalVisible}
        onCancel={() => {
          setIsEndBreakModalVisible(false);
          setSelectedBreakUser(null);
          setEndTime(null);
        }}
        footer={[
          <Button
            key="cancel"
            onClick={() => {
              setIsEndBreakModalVisible(false);
              setSelectedBreakUser(null);
              setEndTime(null);
            }}
          >
            İptal
          </Button>,
          <Button
            key="confirm"
            type="primary"
            loading={updatingBreak}
            onClick={handleEndBreakConfirm}
            disabled={!endTime}
          >
            Kaydet
          </Button>
        ]}
        width={400}
      >
        {selectedBreakUser && (
          <div>
            <div className="mb-3">
              <strong>Çalışan:</strong> {selectedBreakUser.userName}
            </div>
            <div className="mb-3">
              <strong>Mola Başlangıcı:</strong> {formatTime(selectedBreakUser.startTime)}
            </div>
            <div className="mb-3">
              <label className="form-label">
                <strong>Mola Bitiş Saati:</strong>
              </label>
              <TimePicker
                value={endTime}
                onChange={(time) => setEndTime(time)}
                format="HH:mm"
                locale={locale}
                style={{ width: '100%' }}
                showNow={false}
                minuteStep={1}
              />
            </div>
          </div>
        )}
      </Modal>
    </Modal>
  );

  const renderLateUsersModal = () => (
    <Modal
      title={t("modals.lateEmployees.title")}
      open={isLateUsersModalVisible}
      onCancel={() => setIsLateUsersModalVisible(false)}
      footer={null}
      width={700}
      bodyStyle={{ maxHeight: '60vh', overflow: 'auto' }}
    >
      <div className="table-responsive">
        <table className="table table-nowrap mb-0">
          <thead style={{ position: 'sticky', top: 0, backgroundColor: 'white', zIndex: 1 }}>
            <tr>
              <th>{t("modals.lateEmployees.employee")}</th>
              <th>{t("modals.lateEmployees.shiftStartTime")}</th>
              <th>{t("modals.lateEmployees.delay")}</th>
              <th>{t("modals.lateEmployees.reason")}</th>
            </tr>
          </thead>
          <tbody>
            {filteredCompanyDailyLateUsers?.map((lateUser) => (
              <tr key={lateUser.id}>
                <td>
                  <div className="d-flex align-items-center">
                    <div className="avatar avatar-md me-2">
                      {lateUser.profilePicture ? (
                       <Avatar src={getFileUrl(lateUser.profilePicture)} size="large" />
                      ) : (
                        <Avatar src={lateUser.gender === 'male' ? '/assets/img/man.png' : '/assets/img/woman.png'} size="large" />
                      )}
                    </div>
                    <div>
                      <Link to={all_routes.employeedetails.replace(':id', lateUser.id.toString())}>
                        <h6 className="mb-0">{lateUser.name}</h6>
                        <small>
                          {Array.isArray(lateUser.department) 
                            ? lateUser.department.map(d => d.name).join(', ') 
                            : '-'
                          } - {Array.isArray(lateUser.branch) 
                            ? lateUser.branch.map(b => b.name).join(', ') 
                            : '-'
                          }
                        </small>
                      </Link>
                    </div>
                  </div>
                </td>
                <td>{!lateUser.shiftStartTime || lateUser.shiftStartTime === "Bilinmiyor" ? "-" : lateUser.shiftStartTime.split(':')[0] + ":" + lateUser.shiftStartTime.split(':')[1] }</td>
                <td>{lateUser.lateDuration}</td>
                <td>
                  {lateUser.excuse ? (
                    <div 
                      style={{ cursor: 'pointer' }}
                      title={lateUser.excuse}
                    >
                      <i className="ti ti-info-circle me-1" />
                      {lateUser.excuse}
                    </div>
                  ) : (
                    <span className="text-muted">-</span>
                  )}
                </td>
              </tr>
            ))}
            {companyDailyLateUsers.length === 0 && (
              <tr>
                <td colSpan={4} className="text-center">
                  {t("modals.lateEmployees.noLateToday")}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </Modal>
  );

  const renderCheckedInEmployeesModal = () => (
    <Modal
      title={t("modals.checkedInEmployees.title", "Ofiste Olan Çalışanlar")}
      open={isCheckedInEmployeesModalVisible}
      onCancel={() => setIsCheckedInEmployeesModalVisible(false)}
      footer={null}
      width={700}
      bodyStyle={{ maxHeight: '60vh', overflow: 'auto' }}
    >
      <div className="table-responsive">
        <table className="table table-nowrap mb-0">
          <thead style={{ position: 'sticky', top: 0, backgroundColor: 'white', zIndex: 1 }}>
            <tr>
              <th>{t("modals.checkedInEmployees.employee", "Çalışan")}</th>
              <th>{t("modals.checkedInEmployees.department", "Departman")}</th>
              <th>{t("modals.checkedInEmployees.branch", "Şube")}</th>
              <th>{t("modals.checkedInEmployees.checkInTime", "Giriş Saati")}</th>
            </tr>
          </thead>
          <tbody>
            {filteredCheckedInEmployees?.map((employee) => (
              <tr key={employee.userId}>
                <td>
                  <div className="d-flex align-items-center">
                    <div className="avatar me-2">
                      {employee.profilePicture ? (
                        <Avatar src={getFileUrl(employee.profilePicture)} size="large" />
                      ) : (
                        <Avatar src={employee.gender === 'male' ? '/assets/img/man.png' : '/assets/img/woman.png'} size="large" />
                      )}
                    </div>
                    <div>
                      <Link to={all_routes.employeedetails.replace(':id', employee.userId.toString())}>
                        <h6 className="mb-0">{employee.name}</h6>
                        <small>{employee.title}</small>
                      </Link>
                    </div>
                  </div>
                </td>
                <td>
                  {Array.isArray(employee.department) 
                    ? employee.department.map((d: any) => d.name).join(', ') 
                    : employee.department || '-'
                  }
                </td>
                <td>
                  {Array.isArray(employee.branch) 
                    ? employee.branch.map((b: any) => b.name).join(', ') 
                    : employee.branch || '-'
                  }
                </td>
                <td>{formatTime(employee.entryTime)}</td>
              </tr>
            ))}
            {filteredCheckedInEmployees.length === 0 && (
              <tr>
                <td colSpan={4} className="text-center">
                  {t("modals.checkedInEmployees.noEmployee", "Bugün giriş yapan çalışan bulunmuyor.")}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </Modal>
  );

  return (
    <>
      {/* Page Wrapper */}
        {mainLoading ? (
          <div className="page-wrapper">
            <div className="content">
              <LoadingSpinner centered={true} />
            </div>
          </div>

        ) : (
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">{t('dashboard.pageTitle', {type: user?.role})}</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">{t('dashboard.breadcrumb.dashboard')}</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    {t('dashboard.breadcrumb.adminDashboard')}
                  </li>
                </ol>
              </nav>
            </div>
          </div>
          {/* /Breadcrumb */}
          {/* Welcome Wrap */}
          <div className="card border-0">
            <div className="card-body d-flex align-items-center justify-content-between flex-wrap pb-1">
              <div className="d-flex align-items-center justify-content-between mb-3">
                {/* <span className="avatar avatar-xl flex-shrink-0">
                  <ImageWithBasePath
                    src="assets/img/profiles/avatar-31.jpg"
                    className="rounded-circle"
                    alt="img"
                  />
                </span> */}
                <div className="ms-3">
                  <h3 className="mb-2">
                    {t('dashboard.welcomeBack', {name: user?.firstName})}
                    {/* <Link to="#" className="edit-icon">
                      <i className="ti ti-edit fs-14" />
                    </Link> */}
                  </h3>
                  <p>
                    <Trans
                      i18nKey="dashboard.ticketsLeaves"
                      values={{
                        tickets: companyDailyStats?.createdTickets,
                        leaves: companyDailyStats?.pendingLeaves,
                      }}
                      components={{
                        tickets: (
                          <span
                            className="text-primary "
                            onClick={() => navigate(all_routes.ticketAdmin)}
                            style={{ cursor: 'pointer' }}
                          />
                        ),
                        leaves: (
                          <span
                            className="text-primary "
                            onClick={() => navigate(all_routes.leaveadmin)}
                            style={{ cursor: 'pointer' }}
                          />
                        ),
                      }}
                    />
                  </p>
                </div>
              </div>
              <div className="d-flex align-items-center gap-3 mb-3 flex-wrap">
                <div className="d-flex align-items-center gap-2">
                  <i className="ti ti-filter fs-16 text-muted"></i>
                  <span className="text-muted fs-13 fw-medium">Filtreler:</span>
                </div>
                
                <div className="filter-group d-flex align-items-center gap-2">
                  <Select
                    mode="multiple"
                    placeholder="Departman Seç"
                    value={selectedDepartments}
                    onChange={handleDepartmentFilter}
                    style={{ minWidth: 180 }}
                    allowClear
                    maxTagCount={1}
                    maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} daha`}
                    size="middle"
                    tagRender={(props) => {
                      return (
                        <Tag color="#7338A0" closable onClose={props.onClose} style={{textAlign: 'center', justifyContent: 'center',alignItems: 'center',display: 'flex',flexWrap: 'nowrap'}}>
                          {props.label}
                        </Tag>
                      );
                    }}
                  >
                    {departments?.map((dept) => (
                      <Select.Option key={dept.id} value={dept.id}>
                        <div className="d-flex align-items-center justify-content-between">
                          <span>{dept.name}</span>
                          {/* <span className="text-muted fs-12">({dept.employeeCount})</span> */}
                        </div>
                      </Select.Option>
                    ))}
                  </Select>
                </div>

                <div className="filter-group d-flex align-items-center gap-2">
                  <Select
                    mode="multiple"
                    placeholder="Şube Seç"
                    value={selectedBranches}
                    onChange={handleBranchFilter}
                    style={{ minWidth: 160}}
                    allowClear
                    maxTagCount={1}
                    maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} daha`}
                    size="middle"
                    tagRender={(props) => {
                      return (
                        <Tag color="#7338A0" closable onClose={props.onClose} style={{textAlign: 'center', justifyContent: 'center',alignItems: 'center',display: 'flex',flexWrap: 'nowrap'}}>
                          {props.label}
                        </Tag>
                      );
                    }}
                  >
                    {shops?.map((shop: any) => (
                      <Select.Option key={shop.id} value={shop.id}>
                        <div className="d-flex align-items-center justify-content-between">
                          <span>{shop.name}</span>
                          {/* <span className="text-muted fs-12">({shop.employeeCount})</span> */}
                        </div>
                      </Select.Option>
                    ))}
                  </Select>
                </div>

                {(selectedDepartments.length > 0 || selectedBranches.length > 0) && (
                  <button
                    onClick={clearFilters}
                    className="btn btn-outline-secondary btn-sm d-flex align-items-center gap-1"
                    title="Filtreleri Temizle"
                  >
                    <i className="ti ti-x fs-12"></i>
                    Temizle
                  </button>
                )}
                
              </div>
            </div>
          </div>
          {/* /Welcome Wrap */}
          <div className="row" data-tour="dashboard-stats">
            {/* Widget Info */}
            <div className="col-xxl-4 d-flex">
              <div className="row flex-fill">
                <div className="col-md-6 d-flex">
                  <div className="card flex-fill">
                    <div className="card-body">
                      <span className="avatar rounded-circle bg-primary mb-2">
                        <i className="ti ti-calendar-share fs-16" />
                      </span>
                      <h6 className="fs-13 fw-medium text-default mb-1">
                        {t('dashboard.stats.checkedInEmployees', 'Giriş Yapan Sayısı')}
                      </h6>
                      <h3 className="mb-3 d-flex align-items-center" style={{ minHeight: '32px' }}>
                        {dataLoadingStates.checkedInEmployees ? (
                          <div className="skeleton-text" style={{ width: '60px', height: '24px' }}></div>
                        ) : (
                          
                          <span>{widgetStats.checkedIn}</span>
                        )}
                      </h3>
                        <Link to="#" className="link-default" onClick={handleCheckedInEmployees}>
                          {t('dashboard.departments.viewAll')}
                        </Link>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 d-flex">
                  <div className="card flex-fill">
                    <div className="card-body">
                      <span className="avatar rounded-circle bg-secondary mb-2">
                        <i className="ti ti-browser fs-16" />
                      </span>
                      <h6 className="fs-13 fw-medium text-default mb-1">
                      {t('dashboard.stats.lateEmployees')}
                      </h6>
                      <h3 className="mb-3 d-flex align-items-center" style={{ minHeight: '32px' }}>
                        {dataLoadingStates.lateUsers ? (
                          <div className="skeleton-text" style={{ width: '40px', height: '24px' }}></div>
                        ) : (
                          <span>{widgetStats.late}</span>
                        )}
                      </h3>
                      <Link to="#" className="link-default" onClick={handleCompanyDailyLateUsers}>
                        {t('dashboard.departments.viewAll')}
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 d-flex">
                  <div className="card flex-fill">
                    <div className="card-body">
                      <span className="avatar rounded-circle bg-info mb-2">
                        <i className="ti ti-users-group fs-16" />
                      </span>
                      <h6 className="fs-13 fw-medium text-default mb-1">
                        {t('dashboard.stats.onLeaveEmployees')}
                      </h6>
                      <h3 className="mb-3 d-flex align-items-center" style={{ minHeight: '32px' }}>
                        {dataLoadingStates.leaveUsers ? (
                          <div className="skeleton-text" style={{ width: '40px', height: '24px' }}></div>
                        ) : (
                          <span>{widgetStats.onLeave}</span>
                        )}
                      </h3>
                        <Link to="#" className="link-default" onClick={handleCompanyDailyLeaveUsers}>
                          {t('dashboard.departments.viewAll')}
                        </Link>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 d-flex">
                  <div className="card flex-fill">
                    <div className="card-body">
                      <span className="avatar rounded-circle bg-pink mb-2">
                        <i className="ti ti-checklist fs-16" />
                      </span>
                      <h6 className="fs-13 fw-medium text-default mb-1">
                        {t('dashboard.stats.onBreakEmployees')}
                      </h6>
                      <h3 className="mb-3 d-flex align-items-center" style={{ minHeight: '32px' }}>
                        {dataLoadingStates.activeBreakUsers ? (
                          <div className="skeleton-text" style={{ width: '40px', height: '24px' }}></div>
                        ) : (
                          <span>{widgetStats.onBreak}</span>
                        )}
                      </h3>
                        <Link to="#" className="link-default" onClick={handleActiveBreakUsers}>
                          {t('dashboard.departments.viewAll')}
                        </Link>
                    </div>
                  </div>
                </div>
          
              </div>
            </div>
            {/* /Widget Info */}
            {/* Employees By Department */}
            <div className="col-xxl-4 d-flex">
              <div className="card flex-fill">
                <div className="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
                  <h5 className="mb-2">{t('dashboard.departments.title')}</h5>
                  <Link to="/departments" className="btn btn-light btn-md mb-2">
                    {t('dashboard.departments.viewAll')}
                  </Link>
                </div>
                <div className="card-body">
                  <ReactApexChart
                    id="emp-department"
                    options={empDepartment}
                    series={empDepartment.series}
                    type="bar"
                    height={220}
                  />
                </div>
              </div>
            </div>
            {/* Employees By Branch - Aktifleştirildi */}
            <div className="col-xxl-4 d-flex">
              <div className="card flex-fill">
                <div className="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
                  <h5 className="mb-2">{t('dashboard.branches.title')}</h5>
                  <Link to="/branches" className="btn btn-light btn-md mb-2">
                    {t('dashboard.departments.viewAll')}
                  </Link>
                </div>
                <div className="card-body">
                  <ReactApexChart
                    id="emp-branch"
                    options={empBranch}
                    series={empBranch.series}
                    type="bar"
                    height={220}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            {/* Attendance Overview */}
            <div className="col-xxl-4 col-xl-6 d-flex">
              <div className="card flex-fill">
                <div className="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
                  <h5 className="mb-2">{t('dashboard.attendanceStatus.title', 'Katılım Durumu')}</h5>
                  
                </div>
                <div className="card-body">
                  <div className="chartjs-wrapper-demo position-relative mb-4">
                    <Chart
                      type="doughnut"
                      data={chartData}
                      options={chartOptions}
                      className="w-full attendence-chart md:w-30rem"
                    />
                    <div className="position-absolute text-center attendance-canvas">
                      <p className="fs-13 mb-1">{t('dashboard.attendanceStatus.totalEmployees', 'Toplam Çalışan')}</p>
                      <h3>{computedStats?.totalEmployees || 0}</h3>
                    </div>
                  </div>
                  <h6 className="mb-3">{t('dashboard.attendanceStatus.title', 'Katılım Durumu')}</h6>
                  <div className="d-flex align-items-center justify-content-between mb-2">
                    <p className="f-13 mb-2">
                      <i className="ti ti-circle-filled me-1" style={{ color: '#10b981' }} />
                      {t('dashboard.attendanceStatus.checkedIn', 'Giriş yapan')}
                    </p>
                    <p className="f-13 fw-medium text-gray-9 mb-2">
                      {computedStats?.totalEmployees ?
                        `${Math.round((computedStats.checkedInEmployees / computedStats.totalEmployees) * 100)}%` : '0%'}
                    </p>
                  </div>
                  <div className="d-flex align-items-center justify-content-between">
                    <p className="f-13 mb-2">
                      <i className="ti ti-circle-filled text-danger me-1" />
                      {t('dashboard.attendanceStatus.didNotCome', 'Gelmedi')}
                    </p>
                    <p className="f-13 fw-medium text-gray-9 mb-2">
                      {computedStats?.totalEmployees ?
                        `${Math.round((computedStats.didNotCome / computedStats.totalEmployees) * 100)}%` : '0%'}
                    </p>
                  </div>
                  <div className="d-flex align-items-center justify-content-between">
                    <p className="f-13 mb-2">
                      <i className="ti ti-circle-filled text-secondary me-1" />
                      {t('dashboard.attendanceStatus.late', 'Gecikmeli')}
                    </p>
                    <p className="f-13 fw-medium text-gray-9 mb-2">
                      {computedStats?.totalEmployees ? 
                        `${Math.round((computedStats.lateEmployees / computedStats.totalEmployees) * 100)}%` : '0%'}
                    </p>
                  </div>
                  <div className="d-flex align-items-center justify-content-between">
                    <p className="f-13 mb-2">
                      <i className="ti ti-circle-filled text-primary me-1" style={{fontSize: '14px'}} />
                      {t('dashboard.attendanceStatus.onLeave', 'İzinli')}
                    </p>
                    <p className="f-13 fw-medium text-gray-9 mb-2">
                      {computedStats?.totalEmployees ? 
                        `${Math.round((computedStats.onLeaveEmployees / computedStats.totalEmployees) * 100)}%` : '0%'}
                    </p>
                  </div>
                  <div className="d-flex align-items-center justify-content-between mb-2">
                    <p className="f-13 mb-2">
                      <i className="ti ti-circle-filled text-warning me-1" />
                      {t('dashboard.attendanceStatus.onBreak', 'Molada')}
                    </p>
                    <p className="f-13 fw-medium text-gray-9 mb-2">
                      {computedStats?.totalEmployees ? 
                        `${Math.round((computedStats.activeBreaks / computedStats.totalEmployees) * 100)}%` : '0%'}
                    </p>
                  </div>
                  {'noShiftToday' in (computedStats ?? {}) && (computedStats?.noShiftToday ?? 0) > 0 && (
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <p className="f-13 mb-2">
                        <i className="ti ti-circle-filled me-1" style={{ color: '#6c757d' }} />
                        {t('dashboard.attendanceStatus.noShiftToday', 'Bugün vardiyası yok')}
                      </p>
                      <p className="f-13 fw-medium text-gray-9 mb-2">
                        {computedStats?.totalEmployees
                          ? `${Math.round((computedStats.noShiftToday / computedStats.totalEmployees) * 100)}%`
                          : '0%'}
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
            
            <ClockInOutStatus 
              selectedDepartments={selectedDepartments}
              selectedBranches={selectedBranches}            
            />
            <BreakStatus 
              selectedDepartments={selectedDepartments}
              selectedBranches={selectedBranches}            
            />
            <LeaveStatus 
              selectedDepartments={selectedDepartments}
              selectedBranches={selectedBranches}
            />
            <TicketStatus 
              selectedDepartments={selectedDepartments}
              selectedBranches={selectedBranches}
            />
            <ExcuseStatus 
              selectedDepartments={selectedDepartments}
              selectedBranches={selectedBranches}
            />
            {/* Employees */}
            <div className="col-xxl-4 col-xl-6 d-flex">
              <div className="card flex-fill">
                <div className="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
                  <h5 className="mb-2">{t("dashboard.employees.title")}</h5>
                  <Link
                    to={routes.employeeList}
                    className="btn btn-light btn-md mb-2"
                  >
                    {t("dashboard.employees.viewAll")}
                  </Link>
                </div>
                <div className="card-body p-0" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                  <div className="table-responsive">
                    <table className="table table-nowrap mb-0">
                      <thead style={{ position: 'sticky', top: 0, backgroundColor: 'white', zIndex: 1 }}>
                        <tr>
                          <th>{t("dashboard.employees.name")}</th>
                          <th>{t("dashboard.employees.branch")}</th>
                        </tr>
                      </thead>
                      <tbody>
                      {dataLoadingStates.users ? (
                          // Skeleton loading
                          [...Array(5)].map((_, index) => (
                            <tr key={index}>
                              <td>
                                <div className="d-flex align-items-center">
                                  <div className="skeleton-avatar"></div>
                                  <div className="ms-2">
                                    <div className="skeleton-text" style={{ width: '120px', height: '16px', marginBottom: '4px' }}></div>
                                    <div className="skeleton-text" style={{ width: '80px', height: '12px' }}></div>
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div className="skeleton-text" style={{ width: '60px', height: '16px' }}></div>
                              </td>
                            </tr>
                          ))
                        ) : (
                          filteredCompanyUsers?.map((user) => (
                            <tr key={user.id}>
                            <td>
                              <div className="d-flex align-items-center">
                              {user.profilePicture ? (
                              <Link to={routes.employeedetails.replace(':id', user.id.toString())} className="avatar">
                                <Avatar src={getFileUrl(user.profilePicture)} size="large" />

                              </Link>
                              ) : (
                                <Link to={routes.employeedetails.replace(':id', user.id.toString())} className="avatar">
                                  <Avatar src={user?.gender === 'male' ? '/assets/img/man.png' : '/assets/img/woman.png'} size="large" />
                                </Link>
                              )}

                              <Link to={routes.employeedetails.replace(':id', user.id.toString())} className="ms-2">
                                <h6 className="fw-medium">
                                  {user?.firstName} {user?.lastName}
                                </h6>
                                <span className="fs-12">{user?.department?.map(d => d.name).join(', ') || '-'}</span>
                                </Link>
                            </div>
                          </td>
                          <td>
                            <span className="badge badge-secondary-transparent badge-xs">
                              {user?.branch?.map(b => b.name).join(', ') || '-'}
                            </span>
                          </td>
                        </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            {/* /Employees */}
          {renderBirthdaySection()}
          </div>
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
            <FooterSection />
        </div>
        
      </div>
        )}
      {renderLeaveUsersModal()}
      {renderBreakUsersModal()}
      {renderLateUsersModal()}
      {renderCheckedInEmployeesModal()}
    </>
  );
};

export default AdminDashboard;
